export default "__VITE_ASSET__lzPkqhir__"